import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { Bar, Pie, Line } from "react-chartjs-2";
import { Accordion } from "react-bootstrap";
import "./ImportExportData.css";
import Footer from "../Home/Footer";
import ImportExportSlider from "../assets/img/ImportExportSlider.jpg";

const ImportExportData = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // Sample data for charts
  const tradeData = {
    labels: ["2019", "2020", "2021", "2022", "2023"],
    datasets: [
      {
        label: "Soybean Export (Million Tons)",
        data: [90, 85, 100, 110, 120],
        backgroundColor: "#d4561a", // Yellow
      },
      {
        label: "Soybean Import (Million Tons)",
        data: [80, 95, 105, 120, 130],
        backgroundColor: "black", // Black
      },
    ],
  };
  const reportData = [
    {
      title: "Global Soybean Trade Report 2023",
      image:
        "https://img.freepik.com/free-photo/fresh-green-plant-grows-vibrant-nature-generated-by-ai_188544-151450.jpg",
      pdf: "/path/to/report1.pdf",
    },
    {
      title: "Soybean Export Statistics 2023",
      image:
        "https://media.istockphoto.com/id/1401722160/photo/sunny-plantation-with-growing-soya.jpg?s=612x612&w=0&k=20&c=r_Y3aJ-f-4Oye0qU_TBKvqGUS1BymFHdx3ryPkyyV0w=",
      pdf: "/path/to/report2.pdf",
    },
  ];
  const countryData = {
    labels: ["USA", "Brazil", "Argentina", "China", "India"],
    datasets: [
      {
        data: [30, 40, 15, 50, 10],
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
        ],
      },
    ],
  };

  return (
    // <div className="import-export-page">
    //   {/* Hero Section */}
    //   <section
    //     className="hero-section-import"
    //     style={{
    //       background: `url(${ImportExportSlider}) no-repeat center center/cover`,
    //     }}
    //   >
    //     <div className="overlay"></div>
    //     <div className="container text-center">
    //       <h1 data-aos="fade-down" style={{ color: "#d4561a" }}>
    //         Import & Export Data
    //       </h1>
    //       <p data-aos="fade-up">
    //         Explore the latest statistics, trade routes, and regulations on
    //         global soybean trade.
    //       </p>
    //     </div>
    //   </section>

    //   {/* Global Trade Overview */}
    //   <section className="trade-overview container">
    //     <div className="trade-content">
    //       <div className="trade-text">
    //         <h2
    //           className="import-section-title"
    //           data-aos="fade-up"
    //           style={{ color: "#d4561a" }}
    //         >
    //           🌍 Global Trade Overview
    //         </h2>
    //         <p data-aos="fade-right">
    //           Soybean is one of the most traded agricultural commodities. Major
    //           exporters include <strong>USA, Brazil, and Argentina</strong>,
    //           while
    //           <strong>China</strong> remains the largest importer.
    //         </p>
    //       </div>
    //       <div className="trade-icons" data-aos="fade-left">
    //         <div className="trade-item">
    //           <i className="fas fa-ship"></i>
    //           <h3>Major Exporters</h3>
    //           <p>USA, Brazil, Argentina</p>
    //         </div>
    //         <div className="trade-item">
    //           <i className="fas fa-globe"></i>
    //           <h3>Largest Importer</h3>
    //           <p>China</p>
    //         </div>
    //         <div className="trade-item">
    //           <i className="fas fa-chart-line"></i>
    //           <h3>Market Trends</h3>
    //           <p>Growing demand & fluctuating prices</p>
    //         </div>
    //       </div>
    //     </div>
    //   </section>

    //   {/* Trade Data Visualization */}
    //   <section className="data-visualization container">
    //     <h2 className="import-section-title" data-aos="fade-up">
    //       Trade Trends & Data
    //     </h2>
    //     <div className="charts">
    //       <div className="chart-container" data-aos="fade-left">
    //         <Bar data={tradeData} />
    //       </div>
    //       <div className="chart-container" data-aos="fade-right">
    //         <Pie data={countryData} />
    //       </div>
    //     </div>
    //   </section>

    //   {/* Regulations & Policies */}
    //   <section className="trade-policies container">
    //     <h2 className="import-section-title" data-aos="fade-up">
    //       Key Regulations & Trade Policies
    //     </h2>
    //     <Accordion>
    //       <Accordion.Item eventKey="0">
    //         <Accordion.Header>Import Tariffs & Taxes</Accordion.Header>
    //         <Accordion.Body>
    //           Different countries impose specific tariffs on soybean imports to
    //           regulate trade and protect local producers.
    //         </Accordion.Body>
    //       </Accordion.Item>
    //       <Accordion.Item eventKey="1">
    //         <Accordion.Header>Export Subsidies & Incentives</Accordion.Header>
    //         <Accordion.Body>
    //           Many soybean-exporting countries provide subsidies to farmers to
    //           boost production and trade.
    //         </Accordion.Body>
    //       </Accordion.Item>
    //     </Accordion>
    //   </section>

    //   {/* Recent Reports & Downloads */}
    //   <section className="trade-reports container">
    //     <h2 className="import-section-title" data-aos="fade-up">
    //       📊 Recent Trade Reports
    //     </h2>
    //     <div className="reports-grid">
    //       {reportData.map((report, index) => (
    //         <div key={index} className="report-card" data-aos="zoom-in">
    //           <img src={report.image} alt={report.title} />
    //           <div className="report-content">
    //             <h3>{report.title}</h3>
    //           </div>
    //           {/* Added this div to keep button inside the card */}
    //           <div className="report-footer">
    //             <a href={report.pdf} download className="btn">
    //               📥 Download PDF
    //             </a>
    //           </div>
    //         </div>
    //       ))}
    //     </div>
    //   </section>

    //   <Footer />
    // </div>
    <section id="recent-posts" className="recent-posts section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div
              className="p-5 rounded shadow"
              style={{ backgroundColor: "#fff8e1" }}
            >
              <h2
                className="mb-3"
                style={{ fontSize: "2rem", color: "#ff6f00" }}
              >
                🚧 Coming Soon
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#555" }}>
                This section is under construction. Stay tuned for our latest
                posts and updates!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImportExportData;
